module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "Badge2.4a018a3e.png";